export default {"src":"/_next/static/media/digital-art-grid-method.0e8d80fb.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};